export default __webpack_public_path__ + "static/media/absorbant_details.dbc8ba35.webp";